import { render } from "./IncallOriginTicket.vue?vue&type=template&id=fb71c26e&scoped=true"
import script from "./IncallOriginTicket.vue?vue&type=script&lang=js"
export * from "./IncallOriginTicket.vue?vue&type=script&lang=js"

import "./IncallOriginTicket.vue?vue&type=style&index=0&id=fb71c26e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb71c26e"]])

export default __exports__